import { token } from '@zillow/constellation';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    padding: 0;
    margin: 0;
    font-family: ${token('fonts.sansSerif')};

    /* Override NotificationCenter CSS */
    &.Utils-lock-body {
      height: 100%;
    }
  }

  * {
    box-sizing: border-box;
  }

  #sticky-container {
    height: 100%;
  }

  #App {
    height: 100%;
    background-color: ${token('colors.backgroundWhite')};
  }
`;
